import React from 'react';
import PropTypes from 'prop-types';

import { formatPhoneNumber } from 'common/formatters';

import { LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS } from 'common/listingConstants';

import SrText from 'client/components/SrText';

import './SrAccountManagerContactSupport.less';

const SrAccountManagerContactSupport = ({ accountManager }) => {
  const onClickPhoneNumber = () => {
    global.location.href = `tel:+1${LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS}`;
  };

  return (
    <div styleName="component">
      <div styleName="container">
        <SrText font="greycliff" weight="800">
          Get help with this listing
        </SrText>
        <SrText font="greycliff" weight="500" color="grey300" align="center">
          Contact your Account Manager to get help editing your listing.
        </SrText>
        <SrText font="greycliff" weight="500" color="grey300" paddingTop="17px">
          {accountManager.email}
        </SrText>
        <SrText
          font="greycliff"
          weight="500"
          color="blue300"
          cursor="pointer"
          onClick={onClickPhoneNumber}
        >
          {formatPhoneNumber(LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS)}
        </SrText>
      </div>
    </div>
  );
};

SrAccountManagerContactSupport.propTypes = {
  accountManager: PropTypes.object.isRequired,
};

SrAccountManagerContactSupport.displayName = 'SrAccountManagerContactSupport';

export default SrAccountManagerContactSupport;
